	<div [ngClass]='classes()' kendoTooltip [title]="tooltip" (click)='onClick(this.icon.id)'>
		<i [ngClass]='iconClasses()'></i>
		<label *ngIf='hasCaption()'	[ngClass]='captionClasses()' >
			{{this.icon.caption.text}}
		</label>
	</div>
